package com.milta.feature.optimizationquota.domain.usecase

import com.milta.feature.optimizationquota.domain.entity.OptimizationQuota
import com.milta.feature.optimizationquota.domain.repository.OptimizationQuotaRepository

class ReplaceRemainingOptimizationsUseCase(private val repository: OptimizationQuotaRepository) {
    suspend operator fun invoke(accountId: String, remaining: Int): Result<OptimizationQuota> =
        repository.replaceRemaining(accountId, remaining)
}
